import { useQuery, useSubscription } from "react-apollo"
import { METRIC_SETTINGS } from "@modules/metrics/metrics"
import unzipCamelCaseStr from "@modules/toolkit/helpers/unzipCamelCaseStr"
import {
  REPORTS_FOR_BUILD,
  BUILD_REPORT_CREATED,
  AVAILABLE_PLUGINS_QUERY,
} from "@modules/metrics/queries"
import { updateCacheOnReportAdded } from "@modules/metrics/apollo/updateCacheOnReportAdded"
import { ReportPluginVendor } from "@modules/graphql/types"

const extractLighthouseScores = ({ data, settings }) =>
  data.reduce((acc, item) => {
    if (settings?.[item.key]?.featuredOnBuild) {
      return [...acc, [unzipCamelCaseStr({ str: item.key }), item.value]]
    } else {
      return acc
    }
  }, [])

export default function useLighthouseScoresForBuild(siteId, buildId, branch) {
  const {
    data: availablePluginsData,
    loading: availablePluginsLoading,
  } = useQuery(AVAILABLE_PLUGINS_QUERY, {
    variables: {
      siteId,
    },
  })

  const { data, ...restData } = useQuery(REPORTS_FOR_BUILD, {
    variables: {
      siteId,
      buildId,
    },
  })

  useSubscription(BUILD_REPORT_CREATED, {
    variables: {
      buildId,
    },
    onSubscriptionData: updateCacheOnReportAdded({
      query: REPORTS_FOR_BUILD,
      resolverName: `reportsForBuild`,
      payloadName: `buildReportCreated`,
      siteId,
      buildId,
      branch,
    }),
  })

  const availablePlugins =
    (availablePluginsData && availablePluginsData.availableReportPlugins) || []

  let lighthouseEnabled

  if (availablePlugins && availablePlugins.length > 0) {
    const lighthouseReport = availablePlugins.find(plugin => {
      return plugin.vendor === ReportPluginVendor.Lighthouse
    })

    lighthouseEnabled = lighthouseReport?.enabled
  }

  const reportsForBuild = (data && data.reportsForBuild) || []

  const lighthouseScores =
    reportsForBuild.length > 0
      ? extractLighthouseScores({
          data: reportsForBuild[0].metrics,
          settings: METRIC_SETTINGS,
        })
      : []

  if (!lighthouseEnabled) {
    lighthouseEnabled = lighthouseScores?.length > 0
  }

  return [
    lighthouseScores || [],
    { ...restData, lighthouseEnabled, availablePluginsLoading },
  ]
}
